import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const HOME_BY_ROLE = {
  superadmin: "/admin",
  jefe_sector: "/admin",
  supervisor_zona: "/admin",
  director: "/admin",
  docente: "/docente",
};

export function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB]">
        <div className="text-sm text-[#545454]">Cargando…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  const allowed = Array.isArray(roles) ? roles : (roles ? [roles] : null);
  if (allowed && !allowed.includes(user.role)) {
    return <Navigate to={HOME_BY_ROLE[user.role] || "/login"} replace />;
  }
  // Force profile completion for docente & director before using the app.
  if (!user.perfil_completo && (user.role === "docente" || user.role === "director")) {
    const perfilPath = user.role === "director" ? "/admin/perfil" : "/perfil";
    if (path !== perfilPath) {
      return <Navigate to={perfilPath} replace />;
    }
  }
  return children;
}
